module.exports = __webpack_public_path__ + "static/media/FormatoSimplificado_306225.3904f46e.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/ift/InternetSatF/FormatoSimplificado_306225.pdf
// module id = 336
// module chunks = 0